import tags from './tags';

export default tags;
